import { Box } from '@mui/material'
import React from 'react'
import CardTeam from '../components/homePage/CardTeam'
import Title from '../components/homePage/Title'
import bgDoted from './../assets/CardService/nav.png'
import { useTranslation } from 'react-i18next'
import imgBoss from './../assets/Home/chairmanMessage.png'
import i18next from 'i18next'

function ChairmansMessage() {
    const { t } = useTranslation()
    let lng = i18next.language
    return (
        <div><Box sx={{ display: "flex", flexDirection: { md: "row", xs: "column" } }} className="d-flex homeV">
            <img src={bgDoted} alt="" className='imgDoted' />
            <CardTeam myTitle={<Title title={t('chairmanMessage')} />}
                descHome={t('descChMessage')}
                descComp={t('descChMessageComp')}
                imgCard={imgBoss}
                nameWorking={lng === 'ar' ? 'رئيس مجلس الإدارة ' :'Chairman'}
                name={lng === 'ar' ? 'طارق حميد' :'Tareq Hamid'} />
        </Box></div>
    )
}

export default ChairmansMessage